// extracted by mini-css-extract-plugin
export default {"formulario":"searchbar_formulario__dThJ3"};